// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "root-2sk-J";
var _5 = "wrapper-1w2Yo";
var _6 = "title-4cSfx";
var _7 = "breadcrumbs-3a72b";
var _8 = "loading-38t3y";
var _9 = "close-7FfSo";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "root", _5 as "wrapper", _6 as "title", _7 as "breadcrumbs", _8 as "loading", _9 as "close" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "root": _4, "wrapper": _5, "title": _6, "breadcrumbs": _7, "loading": _8, "close": _9 }
